export interface DeviceInfo {
  isMobile: boolean;
  isIOS: boolean;
  isAndroid: boolean;
  isDesktop: boolean;
}

export const getDeviceInfo = (): DeviceInfo => {
  const userAgent = typeof window !== 'undefined' ? navigator.userAgent || navigator.vendor : '';

  const isIOS = /iPad|iPhone|iPod/.test(userAgent) || 
                (navigator.userAgent.includes("Mac") && "ontouchend" in document);

  const isAndroid = /android/i.test(userAgent);
  const isMobile = isIOS || isAndroid;
  const isDesktop = !isMobile;

  return {
    isMobile,
    isIOS,
    isAndroid,
    isDesktop,
  };
};

export const toggleFullscreen = async (
  element: HTMLElement,
  isCurrentlyFullscreen: boolean,
  gameOrientation: string = "landscape"
): Promise<void> => {
  try {
    if (!isCurrentlyFullscreen) {
      if (element.requestFullscreen) {
        await element.requestFullscreen();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } else if ((element as any).webkitRequestFullscreen) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await (element as any).webkitRequestFullscreen();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } else if ((element as any).webkitEnterFullscreen) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await (element as any).webkitEnterFullscreen();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } else if ((element as any).mozRequestFullScreen) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await (element as any).mozRequestFullScreen();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } else if ((element as any).msRequestFullscreen) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await (element as any).msRequestFullscreen();
      }

      if (gameOrientation === "landscape") {
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
          await (screen.orientation as any)?.lock?.("landscape");
        } catch (err) {
          console.warn("Orientation lock failed:", err);
        }
      }
    } else {
      if (document.exitFullscreen) {
        await document.exitFullscreen();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } else if ((document as any).webkitExitFullscreen) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await (document as any).webkitExitFullscreen();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } else if ((document as any).webkitCancelFullScreen) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await (document as any).webkitCancelFullScreen();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } else if ((document as any).mozCancelFullScreen) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await (document as any).mozCancelFullScreen();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } else if ((document as any).msExitFullscreen) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await (document as any).msExitFullscreen();
      }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((screen.orientation as any)?.unlock) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (screen.orientation as any).unlock();
      }
    }
  } catch (error) {
    console.error("Fullscreen toggle error:", error);
  }
};

